import { useState } from "react";
import AdminDashboard from "./AdminDashboard";
import { initAdminSession, logAdminAction } from "../utils/adminLogger";

const PASSWORDS = {
  "tsarena2024": "super",
  "tsquare2025": "viewer",
};
const SESSION_KEY  = "tsarena_admin_auth";
const ROLE_KEY     = "adminRole";

export default function AdminGuard() {
  const [authed, setAuthed]   = useState(() => sessionStorage.getItem(SESSION_KEY) === "1");
  const [role,   setRole]     = useState(() => sessionStorage.getItem(ROLE_KEY) || "viewer");
  const [input,  setInput]    = useState("");
  const [error,  setError]    = useState(false);
  const [visible, setVisible] = useState(false);

  if (authed) return <AdminDashboard role={role} />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const matched = PASSWORDS[input];
    if (matched) {
      sessionStorage.setItem(SESSION_KEY, "1");
      sessionStorage.setItem(ROLE_KEY, matched);
      const sessionId = await initAdminSession();
      await logAdminAction("login", `Admin logged in — role: ${matched}, session ${sessionId}`);
      setRole(matched);
      setAuthed(true);
    } else {
      setError(true);
      setInput("");
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4">
      <div className="w-full max-w-sm">

        {/* Logo */}
        <div className="flex items-center justify-center gap-2.5 mb-8">
          <div className="w-9 h-9 rounded-xl bg-[#f59e0b] flex items-center justify-center flex-shrink-0">
            <span className="text-base leading-none">🏏</span>
          </div>
          <span className="font-bold text-xl tracking-tight text-black">
            Town Square <span className="text-[#f59e0b]">Arena</span>
          </span>
        </div>

        {/* Card */}
        <div className="bg-white border border-black/8 rounded-3xl shadow-sm px-8 py-10">
          <h1 className="text-black font-black text-2xl tracking-tight mb-1 text-center"
              style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
            Admin Access
          </h1>
          <p className="text-black/40 text-sm text-center mb-8">Enter your password to continue</p>

          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className="relative">
              <input
                type={visible ? "text" : "password"}
                value={input}
                onChange={(e) => { setInput(e.target.value); setError(false); }}
                placeholder="Password"
                autoFocus
                className={`w-full border rounded-xl px-4 py-3 text-sm text-black bg-black/[0.02] pr-11 focus:outline-none focus:ring-2 focus:ring-[#f59e0b]/40 focus:border-[#f59e0b]/60 transition-all ${
                  error ? "border-red-300 bg-red-50/30" : "border-black/10"
                }`}
              />
              <button
                type="button"
                onClick={() => setVisible((v) => !v)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-black/30 hover:text-black/60 transition-colors text-xs font-semibold"
              >
                {visible ? "HIDE" : "SHOW"}
              </button>
            </div>

            {error && (
              <p className="text-red-500 text-sm font-medium text-center -mt-1">
                Incorrect password
              </p>
            )}

            <button
              type="submit"
              className="w-full bg-[#f59e0b] hover:bg-amber-400 text-black font-black text-sm py-3 rounded-xl transition-all hover:shadow-lg hover:shadow-[#f59e0b]/25 hover:-translate-y-0.5 active:translate-y-0"
            >
              Enter
            </button>
          </form>
        </div>

      </div>
    </div>
  );
}
